import { configureStore, ThunkAction, Action } from '@reduxjs/toolkit';
import { setupListeners } from '@reduxjs/toolkit/dist/query';
import { interactSlice} from './slice/interactSlice';
import { mapSlice} from './slice/mapSlice';
 
import { searchSlice } from './slice/searchSlice';

import { adressApi  } from './slice/fetchAdressApi';
import { gstkApi } from './slice/fetchGstkApi';

export const store = configureStore({
  reducer: {
    map: mapSlice.reducer,
    interact: interactSlice.reducer,
 
     search: searchSlice.reducer,
      [adressApi.reducerPath]: adressApi.reducer, // register the adress fetch api
      [gstkApi.reducerPath]: gstkApi.reducer,// register the gst feacth api
  },
  /* Adding the api middleware enables caching, invalidation, polling,and other useful features of `rtk-query`. */
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoreState:false,
        immutableCheck:false
      }
    })   ,
});

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch

export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>;
 

/* optional, but required for refetchOnFocus/refetchOnReconnect behaviors 
* see `setupListeners` docs - takes an optional callback as the 2nd arg for customization 
*/
setupListeners(store.dispatch);


